import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListQueryPaginationPayload } from '@typings/requestPayloads'
import { listInitialState } from '@utils/constants/requestConstants'
import { listSideEffectReducers } from '../reducers'

const externalEmployeesSlice = createSlice({
    name: 'hub/external-employees/list',
    initialState: listInitialState,
    reducers: {
        onRequest(state, action: PayloadAction<IListQueryPaginationPayload>) {
            state.status = STATUS.RUNNING
        },
        ...listSideEffectReducers,
        onChangeData(state, action) {
            const updatedEmployeeIndex = state.data?.findIndex(item => item._id === action.payload.id)
            if (updatedEmployeeIndex >= 0) {
                Object.keys(action.payload.data).forEach(key => {
                    state.data[updatedEmployeeIndex][key] = action.payload.data[key]
                })
            }
        }
    }
})

export const externalEmployeesActions = externalEmployeesSlice.actions
export default externalEmployeesSlice.reducer
